import { render, staticRenderFns } from "./HomeSection.vue?vue&type=template&id=8027cb22&scoped=true"
import script from "./HomeSection.vue?vue&type=script&lang=js"
export * from "./HomeSection.vue?vue&type=script&lang=js"
import style0 from "./HomeSection.vue?vue&type=style&index=0&id=8027cb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8027cb22",
  null
  
)

export default component.exports